<template>
  <div
    ref="elRef"
    v-waypoint="{
      active: true,
      callback: onWaypoint,
      options: intersectionOptions,
    }"
    class="py-4 px-2 border rounded-md relative"
    :class="[!confirmed && 'opacity-75', !isUserMessageAuthor && 'bg-blue-400']"
  >
    <div class="mb-1">
      <span
        class="font-semibold"
        :class="isUserMessageAuthor ? 'text-gray-800' : 'text-white'"
      >
        {{
          isUserMessageAuthor ? user.display_name : message.author.display_name
        }}
      </span>
      <span
        class="text-sm pl-4 float-right"
        :class="isUserMessageAuthor ? 'text-gray-500' : 'text-gray-100'"
        >{{ $filters.date(message.ts, 'HH:mm, Y-MM-DD ') }}</span
      >
    </div>
    <div :class="[isUserMessageAuthor ? 'text-gray-700' : 'text-gray-100']">
      {{ message.text }}
    </div>

    <div
      v-if="DEBUG"
      class="absolute right-0 top-0 mr-2 mt-2 h-6 w-6"
      :class="[message.already_read ? 'bg-green-400' : 'bg-pink-400']"
    ></div>
  </div>
</template>

<script>
import { computed, ref } from '@vue/composition-api'
import useMessages from './useMessages'
import useUser from '@/states/useUser'

const DEBUG = false // set to true in order to view green/red indicator of seen (green) / unseen (red)

export default {
  name: 'Message',
  props: {
    message: {
      type: Object,
      default: () => ({}),
    },
    isLatestViewed: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit, root }) {
    const { user } = useUser()
    const confirmed = computed(() => {
      return !!props.message.id
    })

    const isUserMessageAuthor = computed(() => {
      return user.value.id === props.message.author.id
    })

    const elRef = ref(null)
    const onWaypoint = ({ going, direction }) => {
      if (going === root.$waypointMap.GOING_IN) {
        emit('onViewStart', props.message)
      }
    }

    return {
      user,
      confirmed,
      isUserMessageAuthor,

      elRef,
      onWaypoint,
      intersectionOptions: {
        root: null,
        rootMargin: '0px 0px 0px 0px',
        threshold: [1, 0.25],
      },

      DEBUG,
    }
  },
}
</script>
